const supportSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 2C6.81 2 3 5.81 3 10.5C3 15.19 6.81 19 11.5 19H12V22C16.86 19.66 20 15 20 10.5C20 5.81 16.19 2 11.5 2ZM12.5 16.5H10.5V14.5H12.5V16.5ZM12.5 13H10.5C10.5 9.75 13.5 10 13.5 8C13.5 6.9 12.6 6 11.5 6C10.4 6 9.5 6.9 9.5 8H7.5C7.5 5.79 9.29 4 11.5 4C13.71 4 15.5 5.79 15.5 8C15.5 10.5 12.5 10.75 12.5 13Z"
      fill="#B6B4BA"
    />
  </svg>
);

const billingSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.30167 4H15.6983C16.5998 4 17.0501 4 17.4141 4.1304C17.7573 4.2555 18.0678 4.46032 18.3216 4.72893C18.5753 4.99754 18.7654 5.32271 18.8771 5.67916C19 6.06475 19 6.54154 19 7.49592V18.6989C19 19.3853 18.2339 19.7501 17.7493 19.2941C17.6134 19.1649 17.4351 19.0931 17.25 19.0931C17.0649 19.0931 16.8866 19.1649 16.7507 19.2941L16.375 19.6477C16.1368 19.8742 15.8244 20 15.5 20C15.1756 20 14.8632 19.8742 14.625 19.6477C14.3868 19.4211 14.0744 19.2953 13.75 19.2953C13.4256 19.2953 13.1132 19.4211 12.875 19.6477C12.6368 19.8742 12.3244 20 12 20C11.6756 20 11.3632 19.8742 11.125 19.6477C10.8868 19.4211 10.5744 19.2953 10.25 19.2953C9.92562 19.2953 9.61316 19.4211 9.375 19.6477C9.13684 19.8742 8.82438 20 8.5 20C8.17562 20 7.86316 19.8742 7.625 19.6477L7.24933 19.2941C7.11339 19.1649 6.93509 19.0931 6.75 19.0931C6.56491 19.0931 6.38661 19.1649 6.25067 19.2941C5.76611 19.7501 5 19.3853 5 18.6989V7.49592C5 6.54154 5 6.06395 5.12289 5.67996C5.35622 4.94958 5.89678 4.37679 6.58589 4.1304C6.94989 4 7.40022 4 8.30167 4ZM8.11111 7.79992C7.9564 7.79992 7.80803 7.86313 7.69863 7.97565C7.58924 8.08817 7.52778 8.24078 7.52778 8.3999C7.52778 8.55903 7.58924 8.71164 7.69863 8.82416C7.80803 8.93668 7.9564 8.99989 8.11111 8.99989H8.5C8.65471 8.99989 8.80308 8.93668 8.91248 8.82416C9.02187 8.71164 9.08333 8.55903 9.08333 8.3999C9.08333 8.24078 9.02187 8.08817 8.91248 7.97565C8.80308 7.86313 8.65471 7.79992 8.5 7.79992H8.11111ZM10.8333 7.79992C10.6786 7.79992 10.5303 7.86313 10.4209 7.97565C10.3115 8.08817 10.25 8.24078 10.25 8.3999C10.25 8.55903 10.3115 8.71164 10.4209 8.82416C10.5303 8.93668 10.6786 8.99989 10.8333 8.99989H15.8889C16.0436 8.99989 16.192 8.93668 16.3014 8.82416C16.4108 8.71164 16.4722 8.55903 16.4722 8.3999C16.4722 8.24078 16.4108 8.08817 16.3014 7.97565C16.192 7.86313 16.0436 7.79992 15.8889 7.79992H10.8333ZM8.11111 10.5999C7.9564 10.5999 7.80803 10.6631 7.69863 10.7756C7.58924 10.8881 7.52778 11.0407 7.52778 11.1998C7.52778 11.359 7.58924 11.5116 7.69863 11.6241C7.80803 11.7366 7.9564 11.7998 8.11111 11.7998H8.5C8.65471 11.7998 8.80308 11.7366 8.91248 11.6241C9.02187 11.5116 9.08333 11.359 9.08333 11.1998C9.08333 11.0407 9.02187 10.8881 8.91248 10.7756C8.80308 10.6631 8.65471 10.5999 8.5 10.5999H8.11111ZM10.8333 10.5999C10.6786 10.5999 10.5303 10.6631 10.4209 10.7756C10.3115 10.8881 10.25 11.0407 10.25 11.1998C10.25 11.359 10.3115 11.5116 10.4209 11.6241C10.5303 11.7366 10.6786 11.7998 10.8333 11.7998H15.8889C16.0436 11.7998 16.192 11.7366 16.3014 11.6241C16.4108 11.5116 16.4722 11.359 16.4722 11.1998C16.4722 11.0407 16.4108 10.8881 16.3014 10.7756C16.192 10.6631 16.0436 10.5999 15.8889 10.5999H10.8333ZM8.11111 13.3998C7.9564 13.3998 7.80803 13.463 7.69863 13.5755C7.58924 13.688 7.52778 13.8407 7.52778 13.9998C7.52778 14.1589 7.58924 14.3115 7.69863 14.424C7.80803 14.5366 7.9564 14.5998 8.11111 14.5998H8.5C8.65471 14.5998 8.80308 14.5366 8.91248 14.424C9.02187 14.3115 9.08333 14.1589 9.08333 13.9998C9.08333 13.8407 9.02187 13.688 8.91248 13.5755C8.80308 13.463 8.65471 13.3998 8.5 13.3998H8.11111ZM10.8333 13.3998C10.6786 13.3998 10.5303 13.463 10.4209 13.5755C10.3115 13.688 10.25 13.8407 10.25 13.9998C10.25 14.1589 10.3115 14.3115 10.4209 14.424C10.5303 14.5366 10.6786 14.5998 10.8333 14.5998H15.8889C16.0436 14.5998 16.192 14.5366 16.3014 14.424C16.4108 14.3115 16.4722 14.1589 16.4722 13.9998C16.4722 13.8407 16.4108 13.688 16.3014 13.5755C16.192 13.463 16.0436 13.3998 15.8889 13.3998H10.8333Z"
      fill="#B6B4BA"
    />
  </svg>
);

const homeSvg = (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z" fill="#B6B4BA" />
  </svg>
);

const userSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clip-rule="evenodd"
      d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM15 9C15 10.6575 13.6575 12 12 12C10.3425 12 9 10.6575 9 9C9 7.3425 10.3425 6 12 6C13.6575 6 15 7.3425 15 9ZM6 16.6667C6 14.8933 9.9975 14 12 14C14.0025 14 18 14.8933 18 16.6667V18H6V16.6667Z"
      fill="#B6B4BA"
    />
  </svg>
);

const selectedAccountSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C8.14 2 5 5.14 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.14 15.86 2 12 2ZM12 4C13.1 4 14 4.9 14 6C14 7.11 13.1 8 12 8C10.9 8 10 7.11 10 6C10 4.9 10.9 4 12 4ZM12 14C10.33 14 8.86 13.15 8 11.85C8.02 10.53 10.67 9.8 12 9.8C13.33 9.8 15.98 10.53 16 11.85C15.14 13.15 13.67 14 12 14Z"
      fill="#B6B4BA"
    />
  </svg>
);

const supportSvgWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path
      d="M11.5 2C6.81 2 3 5.81 3 10.5C3 15.19 6.81 19 11.5 19H12V22C16.86 19.66 20 15 20 10.5C20 5.81 16.19 2 11.5 2ZM12.5 16.5H10.5V14.5H12.5V16.5ZM12.5 13H10.5C10.5 9.75 13.5 10 13.5 8C13.5 6.9 12.6 6 11.5 6C10.4 6 9.5 6.9 9.5 8H7.5C7.5 5.79 9.29 4 11.5 4C13.71 4 15.5 5.79 15.5 8C15.5 10.5 12.5 10.75 12.5 13Z"
      fill="green"
    />
  </svg>
);

const billingSvgWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.30167 4H15.6983C16.5998 4 17.0501 4 17.4141 4.1304C17.7573 4.2555 18.0678 4.46032 18.3216 4.72893C18.5753 4.99754 18.7654 5.32271 18.8771 5.67916C19 6.06475 19 6.54154 19 7.49592V18.6989C19 19.3853 18.2339 19.7501 17.7493 19.2941C17.6134 19.1649 17.4351 19.0931 17.25 19.0931C17.0649 19.0931 16.8866 19.1649 16.7507 19.2941L16.375 19.6477C16.1368 19.8742 15.8244 20 15.5 20C15.1756 20 14.8632 19.8742 14.625 19.6477C14.3868 19.4211 14.0744 19.2953 13.75 19.2953C13.4256 19.2953 13.1132 19.4211 12.875 19.6477C12.6368 19.8742 12.3244 20 12 20C11.6756 20 11.3632 19.8742 11.125 19.6477C10.8868 19.4211 10.5744 19.2953 10.25 19.2953C9.92562 19.2953 9.61316 19.4211 9.375 19.6477C9.13684 19.8742 8.82438 20 8.5 20C8.17562 20 7.86316 19.8742 7.625 19.6477L7.24933 19.2941C7.11339 19.1649 6.93509 19.0931 6.75 19.0931C6.56491 19.0931 6.38661 19.1649 6.25067 19.2941C5.76611 19.7501 5 19.3853 5 18.6989V7.49592C5 6.54154 5 6.06395 5.12289 5.67996C5.35622 4.94958 5.89678 4.37679 6.58589 4.1304C6.94989 4 7.40022 4 8.30167 4ZM8.11111 7.79992C7.9564 7.79992 7.80803 7.86313 7.69863 7.97565C7.58924 8.08817 7.52778 8.24078 7.52778 8.3999C7.52778 8.55903 7.58924 8.71164 7.69863 8.82416C7.80803 8.93668 7.9564 8.99989 8.11111 8.99989H8.5C8.65471 8.99989 8.80308 8.93668 8.91248 8.82416C9.02187 8.71164 9.08333 8.55903 9.08333 8.3999C9.08333 8.24078 9.02187 8.08817 8.91248 7.97565C8.80308 7.86313 8.65471 7.79992 8.5 7.79992H8.11111ZM10.8333 7.79992C10.6786 7.79992 10.5303 7.86313 10.4209 7.97565C10.3115 8.08817 10.25 8.24078 10.25 8.3999C10.25 8.55903 10.3115 8.71164 10.4209 8.82416C10.5303 8.93668 10.6786 8.99989 10.8333 8.99989H15.8889C16.0436 8.99989 16.192 8.93668 16.3014 8.82416C16.4108 8.71164 16.4722 8.55903 16.4722 8.3999C16.4722 8.24078 16.4108 8.08817 16.3014 7.97565C16.192 7.86313 16.0436 7.79992 15.8889 7.79992H10.8333ZM8.11111 10.5999C7.9564 10.5999 7.80803 10.6631 7.69863 10.7756C7.58924 10.8881 7.52778 11.0407 7.52778 11.1998C7.52778 11.359 7.58924 11.5116 7.69863 11.6241C7.80803 11.7366 7.9564 11.7998 8.11111 11.7998H8.5C8.65471 11.7998 8.80308 11.7366 8.91248 11.6241C9.02187 11.5116 9.08333 11.359 9.08333 11.1998C9.08333 11.0407 9.02187 10.8881 8.91248 10.7756C8.80308 10.6631 8.65471 10.5999 8.5 10.5999H8.11111ZM10.8333 10.5999C10.6786 10.5999 10.5303 10.6631 10.4209 10.7756C10.3115 10.8881 10.25 11.0407 10.25 11.1998C10.25 11.359 10.3115 11.5116 10.4209 11.6241C10.5303 11.7366 10.6786 11.7998 10.8333 11.7998H15.8889C16.0436 11.7998 16.192 11.7366 16.3014 11.6241C16.4108 11.5116 16.4722 11.359 16.4722 11.1998C16.4722 11.0407 16.4108 10.8881 16.3014 10.7756C16.192 10.6631 16.0436 10.5999 15.8889 10.5999H10.8333ZM8.11111 13.3998C7.9564 13.3998 7.80803 13.463 7.69863 13.5755C7.58924 13.688 7.52778 13.8407 7.52778 13.9998C7.52778 14.1589 7.58924 14.3115 7.69863 14.424C7.80803 14.5366 7.9564 14.5998 8.11111 14.5998H8.5C8.65471 14.5998 8.80308 14.5366 8.91248 14.424C9.02187 14.3115 9.08333 14.1589 9.08333 13.9998C9.08333 13.8407 9.02187 13.688 8.91248 13.5755C8.80308 13.463 8.65471 13.3998 8.5 13.3998H8.11111ZM10.8333 13.3998C10.6786 13.3998 10.5303 13.463 10.4209 13.5755C10.3115 13.688 10.25 13.8407 10.25 13.9998C10.25 14.1589 10.3115 14.3115 10.4209 14.424C10.5303 14.5366 10.6786 14.5998 10.8333 14.5998H15.8889C16.0436 14.5998 16.192 14.5366 16.3014 14.424C16.4108 14.3115 16.4722 14.1589 16.4722 13.9998C16.4722 13.8407 16.4108 13.688 16.3014 13.5755C16.192 13.463 16.0436 13.3998 15.8889 13.3998H10.8333Z"
      fill="white"
    />
  </svg>
);

const homeSvgWhite = (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path d="M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z" fill="white" />
  </svg>
);

const userSvgWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clip-rule="evenodd"
      d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM15 9C15 10.6575 13.6575 12 12 12C10.3425 12 9 10.6575 9 9C9 7.3425 10.3425 6 12 6C13.6575 6 15 7.3425 15 9ZM6 16.6667C6 14.8933 9.9975 14 12 14C14.0025 14 18 14.8933 18 16.6667V18H6V16.6667Z"
      fill="white"
    />
  </svg>
);

const selectedAccountSvgWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C8.14 2 5 5.14 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.14 15.86 2 12 2ZM12 4C13.1 4 14 4.9 14 6C14 7.11 13.1 8 12 8C10.9 8 10 7.11 10 6C10 4.9 10.9 4 12 4ZM12 14C10.33 14 8.86 13.15 8 11.85C8.02 10.53 10.67 9.8 12 9.8C13.33 9.8 15.98 10.53 16 11.85C15.14 13.15 13.67 14 12 14Z"
      fill="white"
    />
  </svg>
);

const arrowDown = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-4 h-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
    />
  </svg>
);

const arrowDownBold = (
  <svg
    className="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
  >
    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
  </svg>
);

const arrowUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-4 h-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 15.75l7.5-7.5 7.5 7.5"
    />
  </svg>
);

const toggleBar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
    />
  </svg>
);

const closeCross = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const downloadFile = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8337 7.5H12.5003V2.5H7.50033V7.5H4.16699L10.0003 13.3333L15.8337 7.5ZM4.16699 15V16.6667H15.8337V15H4.16699Z"
      fill="white"
    />
  </svg>
);

const sendSVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33967 14L15.333 8L1.33967 2L1.33301 6.66667L11.333 8L1.33301 9.33333L1.33967 14Z"
      fill="#FBFAFC"
    />
  </svg>
);

const filterSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
      fill="#84818A"
    />
  </svg>
);

const arrowRight = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    width="24"
    height="24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 4.5l7.5 7.5-7.5 7.5"
    />
  </svg>
);

const arrowLeft = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    width="24"
    height="24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5L8.25 12l7.5-7.5"
    />
  </svg>
);

const clientSupportSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18H5V11.9C5 8.03 8.13 4.9 12 4.9C15.87 4.9 19 8.03 19 11.9V19H11V21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z"
      fill="white"
    />
    <path
      d="M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z"
      fill="white"
    />
    <path
      d="M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z"
      fill="white"
    />
    <path
      d="M18.0005 11.03C17.5205 8.18 15.0405 6 12.0505 6C9.02046 6 5.76046 8.51 6.02046 12.45C8.49046 11.44 10.3505 9.24 10.8805 6.56C12.1905 9.19 14.8805 11 18.0005 11.03Z"
      fill="white"
    />
  </svg>
);

const attachmentSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.942 6.63457L8.03353 12.524C7.09025 13.6558 5.40955 13.8084 4.27776 12.8652C3.14597 11.9219 2.99329 10.2412 3.93656 9.10939L9.27183 2.70788C9.86085 2.00115 10.9125 1.90562 11.6192 2.49463C12.3259 3.08365 12.4215 4.13526 11.8324 4.84199L7.35081 10.2193C7.11606 10.5009 6.69353 10.5393 6.41187 10.3046C6.1302 10.0698 6.09182 9.64728 6.32657 9.36561L10.3814 4.50047L9.61319 3.86023L5.55839 8.72538C4.96937 9.43211 5.06491 10.4837 5.77164 11.0727C6.47836 11.6618 7.52998 11.5662 8.11899 10.8595L12.6006 5.48222C13.5439 4.35043 13.3912 2.66973 12.2594 1.72645C11.1276 0.783176 9.44693 0.935861 8.50365 2.06765L3.16838 8.46916C1.87084 10.026 2.08068 12.3358 3.63753 13.6333C5.19437 14.9309 7.50417 14.721 8.80171 13.1642L13.7102 7.27481L12.942 6.63457Z"
      fill="#84818A"
    />
  </svg>
);

const personSvg = (
  <svg
    width="26"
    height="25"
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8887 12.5128C15.1554 12.5128 16.9913 10.6769 16.9913 8.41027C16.9913 6.14361 15.1554 4.30771 12.8887 4.30771C10.6221 4.30771 8.78616 6.14361 8.78616 8.41027C8.78616 10.6769 10.6221 12.5128 12.8887 12.5128ZM12.8887 14.5641C10.1503 14.5641 4.68359 15.9385 4.68359 18.6667V20.718H21.0938V18.6667C21.0938 15.9385 15.6272 14.5641 12.8887 14.5641Z"
      fill="white"
    />
  </svg>
);

const fileUpload = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="#438E4D" />
  </svg>
);
const closePopUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="white"
    className="w-5 h-5"
  >
    <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
  </svg>
);

const closeCrossWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z"
      fill="#FDFDFD"
    />
  </svg>
);

const attactFileWhite = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4149 9.95192L12.0522 18.786C10.6373 20.4837 8.11627 20.7127 6.41859 19.2978C4.72091 17.8829 4.49188 15.3618 5.9068 13.6641L13.9097 4.06188C14.7932 3.00179 16.3706 2.85849 17.4307 3.74201C18.4908 4.62553 18.6341 6.20295 17.7506 7.26304L11.0282 15.3289C10.676 15.7514 10.0423 15.809 9.61975 15.4569C9.19725 15.1048 9.13968 14.471 9.49181 14.0485L15.574 6.75076L14.4217 5.79041L8.33953 13.0881C7.45601 14.1482 7.59932 15.7256 8.65941 16.6092C9.7195 17.4927 11.2969 17.3494 12.1804 16.2893L18.9029 8.22339C20.3178 6.52571 20.0888 4.00465 18.3911 2.58974C16.6934 1.17482 14.1723 1.40385 12.7574 3.10153L4.75453 12.7038C2.80822 15.0391 3.12297 18.5038 5.45824 20.4501C7.79351 22.3964 11.2582 22.0816 13.2045 19.7464L20.5672 10.9123L19.4149 9.95192Z"
      fill="white"
    />
  </svg>
);
const searchSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
      fill="#84818A"
    />
  </svg>
);

export {
  arrowDown,
  arrowUp,
  supportSvg,
  billingSvg,
  homeSvg,
  userSvg,
  selectedAccountSvg,
  arrowDownBold,
  toggleBar,
  closeCross,
  supportSvgWhite,
  billingSvgWhite,
  homeSvgWhite,
  userSvgWhite,
  selectedAccountSvgWhite,
  downloadFile,
  sendSVG,
  filterSvg,
  arrowRight,
  arrowLeft,
  clientSupportSvg,
  attachmentSvg,
  personSvg,
  fileUpload,
  closePopUp,
  closeCrossWhite,
  attactFileWhite,
  searchSvg,
};
